<template>
  <div class="layout" ref="menuLeft">
    <img class="ip_logo" src="@/assets/images/login/ip_logo.png" alt="logo" @click="toHomePage"/>
    <div class="side_menu">
      <Sider hide-trigger :style="contentStyleObj">
        <Menu
          theme="light"
          ref="menu"
          :active-name="activeName"
          :open-names="openNames"
          @on-select="changeMenu"
          @on-open-change="openNamesChange"
        >
          <div
            @click="goWork()"
            :class="{ lefttit: true, 'lefttit-active': path == 'work' }"
            v-show="PROCESS_ENV.NODE_PLA !== 'wg'"
          >
            <svg
              t="1720693298376"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="11854"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="16"
              height="16"
            >
              <path
                d="M832 192H192c-35.2 0-64 28.8-64 64v384c0 35.2 28.8 64 64 64h288v64h-128v64h320v-64h-128v-64H832c35.2 0 64-28.8 64-64V256c0-35.2-28.8-64-64-64z m-160 352h-320v-64h320v64z m0-128h-320v-64h320v64z"
                p-id="11855"
                fill="#c2c5c6"
              ></path>
            </svg>
            工作台
          </div>
          <div class="dividing-line"></div>
          <div @click="goServiceList()" :class="{ lefttit: true, 'lefttit-active': path == 'serviceList' }">
            <svg t="1721369738045" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15465" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16"><path d="M815.0016 102.4H211.8144a56.832 56.832 0 0 0-56.832 56.7808l-51.2 705.5872c0 31.3856 25.4464 56.832 56.832 56.832h705.5872c31.3856 0 56.7808-25.4464 56.7808-56.7808l-51.2-705.5872A56.832 56.832 0 0 0 815.0016 102.4z m-69.888 281.2928c-3.7376 123.8016-105.0112 223.5392-229.6832 223.5392-124.416 0-225.4336-99.2256-229.632-222.6176a45.568 45.568 0 0 1 20.0192-86.7328c25.344 0 45.8752 20.5312 45.8752 45.8752a45.3632 45.3632 0 0 1-15.36 33.7408 179.4048 179.4048 0 0 0 179.1488 178.5344 179.3024 179.3024 0 0 0 179.0464-177.7664 45.1584 45.1584 0 0 1-16.5376-34.5088 45.8752 45.8752 0 1 1 91.7504 0 45.4656 45.4656 0 0 1-24.6272 39.936z" p-id="15466" fill="#c2c5c6"></path></svg>
            购买服务
          </div>
          <Submenu name="1">
            <template slot="title">
              <svg
                t="1720693042906"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5144"
                width="16"
                height="16"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <path
                  d="M46.805333 516.352a469.333333 469.333333 0 1 1 469.333334 469.333333 468.053333 468.053333 0 0 1-469.333334-469.333333z m490.666667 29.866667l115.2 230.4h81.066667l-128-238.933334 25.6-12.8a138.325333 138.325333 0 0 0 55.466666-55.466666 162.133333 162.133333 0 0 0 21.333334-81.066667 176.170667 176.170667 0 0 0-21.333334-81.066667 136.533333 136.533333 0 0 0-55.466666-55.466666 162.602667 162.602667 0 0 0-81.066667-21.333334h-213.333333v546.133334h64v-230.4z m-140.8-64v-192h153.6a85.76 85.76 0 0 1 46.933333 12.8 79.616 79.616 0 0 1 29.866667 34.133333 116.266667 116.266667 0 0 1 12.8 51.2 92.586667 92.586667 0 0 1-12.8 51.2 67.328 67.328 0 0 1-29.866667 29.866667 85.76 85.76 0 0 1-46.933333 12.8z"
                  p-id="5145"
                  fill="#c2c5c6"
                ></path>
              </svg>
              商标服务
            </template>
            <MenuItem class="menu-item-sub" name="/myBrand"><div class="menu-text">商标注册</div></MenuItem>
            <MenuItem class="menu-item-sub" name="/reviewOpinions"><div class="menu-text">审查意见</div></MenuItem>
          </Submenu>
          <!-- <MenuItem name="/myPatent" class="lefttit">
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.52171 16C6.49945 16 6.47721 15.9985 6.45512 15.9957C6.38726 15.9869 6.32176 15.9646 6.26236 15.9301C6.20297 15.8956 6.15085 15.8496 6.10897 15.7946C6.0671 15.7397 6.03629 15.6769 6.01831 15.6098C6.00033 15.5428 5.99553 15.4728 6.00418 15.4038L7.75309 1.46304C7.76895 1.33518 7.83019 1.2176 7.92532 1.13235C8.02045 1.04709 8.14294 1.00004 8.2698 1H8.27289C8.40036 1.0008 8.52311 1.04904 8.61791 1.13559C8.71271 1.22214 8.77299 1.34099 8.78733 1.46965L10.2823 14.6129C10.2981 14.7523 10.2588 14.8924 10.1729 15.0024C10.0871 15.1124 9.96175 15.1832 9.82449 15.1993C9.68724 15.2154 9.54931 15.1754 9.44105 15.0882C9.33279 15.001 9.26307 14.8737 9.24722 14.7342L8.24457 5.91814L7.03777 15.5376C7.02178 15.6652 6.96057 15.7826 6.86559 15.8677C6.7706 15.9528 6.64836 15.9998 6.52171 16Z"
                fill="#919498"
              />
              <path
                d="M9.71737 13.5149C9.58848 13.515 9.46328 13.472 9.36179 13.3925C9.2603 13.3131 9.18839 13.2019 9.15758 13.0767C9.12677 12.9516 9.13884 12.8197 9.19185 12.7023C9.24486 12.5848 9.33575 12.4885 9.44998 12.4288C9.87079 12.2084 10.2793 11.9651 10.6736 11.7002C11.5029 11.1424 12.2448 10.5115 12.8786 9.82343C13.4837 9.16647 13.9636 8.48755 14.3049 7.80576C14.6344 7.14754 14.8161 6.52477 14.8448 5.9549C14.8721 5.4086 14.7548 4.93644 14.496 4.55137C14.1682 4.06337 13.6323 3.73624 12.9046 3.57969C12.1476 3.41648 11.2213 3.45283 10.2253 3.6846C10.1516 3.70176 10.0752 3.70424 10.0005 3.69189C9.92586 3.67953 9.85434 3.65259 9.79007 3.6126C9.7258 3.57261 9.67003 3.52035 9.62596 3.4588C9.58189 3.39726 9.55037 3.32763 9.5332 3.25391C9.51603 3.18018 9.51355 3.1038 9.52591 3.02911C9.53826 2.95443 9.5652 2.88291 9.6052 2.81864C9.64519 2.75437 9.69745 2.69861 9.75899 2.65453C9.82054 2.61046 9.89016 2.57894 9.96389 2.56177C11.1243 2.29186 12.225 2.25389 13.147 2.45273C14.1619 2.67153 14.9588 3.17501 15.4515 3.90862C15.8521 4.50458 16.0347 5.21247 15.9946 6.0123C15.9586 6.7425 15.7356 7.5193 15.3344 8.32093C14.5389 9.90998 13.1114 11.4494 11.3152 12.6564C10.8861 12.9448 10.4416 13.2096 9.98368 13.4496C9.9015 13.4926 9.81012 13.515 9.71737 13.5149ZM5.21347 7.59217L5.46754 7.87C5.50265 7.90696 5.54542 7.93578 5.59286 7.95444C5.6403 7.97309 5.69126 7.98112 5.74213 7.97796L6.1479 7.95709C6.36041 7.94612 6.4977 8.15107 6.38038 8.30384L6.15617 8.59588C6.12768 8.63185 6.1098 8.67507 6.10456 8.72066C6.09931 8.76626 6.10691 8.81241 6.12648 8.85391L6.27907 9.18212C6.35897 9.35379 6.17777 9.52815 5.97318 9.47723L5.58109 9.3797C5.53134 9.36706 5.47946 9.36521 5.42893 9.37427C5.3784 9.38333 5.3304 9.4031 5.28814 9.43224L4.97577 9.65501C4.81274 9.77215 4.56353 9.67498 4.55399 9.49072L4.536 9.1384C4.53132 9.04663 4.47464 8.96224 4.38485 8.91275L4.03918 8.72292C3.85924 8.62341 3.88569 8.38913 4.08507 8.32705L4.466 8.20685C4.56515 8.17554 4.63982 8.10374 4.66537 8.01485L4.76362 7.67207C4.81508 7.49429 5.08103 7.4466 5.21347 7.59217ZM3.36944 6.537L3.42487 6.72126C3.43261 6.74517 3.44705 6.76636 3.46648 6.7823C3.4859 6.79825 3.50949 6.80829 3.53445 6.81123L3.74264 6.84434C3.8515 6.86144 3.86752 6.99171 3.76963 7.06495L3.58267 7.20422C3.55953 7.22045 3.54025 7.24159 3.52623 7.26614C3.5122 7.29068 3.50376 7.31802 3.50152 7.3462L3.49342 7.54755C3.48928 7.65299 3.35397 7.73109 3.26454 7.67998L3.09378 7.5821C3.06909 7.56945 3.04184 7.56262 3.01411 7.56216C2.98637 7.56169 2.9589 7.56759 2.93381 7.5794L2.72076 7.67207C2.60938 7.72011 2.50969 7.63806 2.55234 7.53333L2.63367 7.33306C2.64439 7.30977 2.64839 7.28395 2.64521 7.25852C2.64203 7.23308 2.6318 7.20904 2.61568 7.18911L2.49206 7.04516C2.42746 6.9694 2.50105 6.84056 2.61675 6.82707L2.83826 6.80026C2.86758 6.79653 2.89586 6.78699 2.92145 6.77218C2.94703 6.75738 2.9694 6.73763 2.98725 6.71407L3.12401 6.53305C3.19544 6.43822 3.34065 6.44056 3.36944 6.537ZM1.9535 10.052L2.02385 10.2679C2.03259 10.2952 2.04888 10.3195 2.07085 10.338C2.09282 10.3565 2.11958 10.3683 2.14801 10.3722L2.37564 10.4072C2.49476 10.4251 2.51959 10.5785 2.41738 10.6664L2.22215 10.8342C2.19747 10.8549 2.17755 10.8806 2.16373 10.9097C2.14991 10.9388 2.14253 10.9706 2.14207 11.0028L2.14459 11.2401C2.14585 11.3641 2.00352 11.4587 1.90365 11.4001L1.71274 11.288C1.68607 11.2736 1.65623 11.266 1.62592 11.266C1.5956 11.266 1.56576 11.2736 1.53909 11.288L1.31291 11.3997C1.19451 11.4584 1.08187 11.3637 1.12235 11.2396L1.19937 11.0024C1.20969 10.9743 1.21262 10.944 1.20786 10.9144C1.2031 10.8849 1.19082 10.8571 1.1722 10.8336L1.03004 10.6655C0.955549 10.5776 1.02824 10.4244 1.15312 10.4064L1.39172 10.3712C1.42376 10.3659 1.45432 10.3539 1.48137 10.3359C1.50842 10.318 1.53135 10.2945 1.54863 10.267L1.68682 10.0511C1.75862 9.93931 1.91679 9.93931 1.9535 10.052ZM4.80806 12.5182L4.91513 12.7809C4.92889 12.8146 4.95126 12.844 4.98 12.8663C5.00875 12.8886 5.04285 12.9029 5.07887 12.9078L5.36498 12.9499C5.51487 12.9718 5.55931 13.1583 5.44037 13.2651L5.21347 13.4696C5.18455 13.495 5.16189 13.5267 5.14725 13.5623C5.13261 13.5979 5.12639 13.6365 5.12908 13.6749L5.15391 13.9628C5.16686 14.1137 4.99844 14.2291 4.86888 14.1576L4.62129 14.0214C4.58799 14.0039 4.55094 13.9948 4.51332 13.9948C4.47571 13.9948 4.43866 14.0039 4.40536 14.0214L4.13383 14.1584C3.99222 14.2303 3.84341 14.1145 3.88191 13.9635L3.95623 13.6756C3.96614 13.64 3.96683 13.6025 3.95824 13.5666C3.94965 13.5307 3.93205 13.4975 3.9071 13.4703L3.71493 13.2659C3.61452 13.159 3.691 12.9726 3.84449 12.9506L4.13887 12.9083C4.17731 12.9024 4.21393 12.8879 4.24604 12.866C4.27815 12.844 4.30492 12.8151 4.32439 12.7815L4.47643 12.5188C4.55615 12.3809 4.7521 12.3809 4.80806 12.5182ZM5.68599 4.39392L5.71136 4.5143C5.71486 4.52985 5.72321 4.54388 5.73521 4.55436C5.74722 4.56484 5.76224 4.57123 5.77812 4.5726L5.91308 4.59239C5.98379 4.60265 5.98649 4.68812 5.91775 4.73634L5.78658 4.82955C5.77048 4.84025 5.75671 4.85408 5.74607 4.87022C5.73544 4.88636 5.72816 4.90447 5.72468 4.92348L5.70668 5.05574C5.69769 5.12484 5.60412 5.17738 5.54834 5.14445L5.44181 5.08183C5.42547 5.07375 5.4075 5.06955 5.38927 5.06955C5.37105 5.06955 5.35307 5.07375 5.33673 5.08183L5.19116 5.14391C5.11504 5.1763 5.0544 5.1234 5.08859 5.05394L5.15391 4.92186C5.16243 4.90752 5.16667 4.89104 5.16613 4.87436C5.16558 4.85769 5.16028 4.84151 5.15085 4.82775L5.07887 4.73383C5.04073 4.6847 5.09687 4.59959 5.17388 4.58987L5.32089 4.57098C5.36115 4.56494 5.39782 4.5444 5.424 4.51322L5.52459 4.39302C5.57731 4.33058 5.67268 4.33094 5.68599 4.39392Z"
                fill="#919498"
              />
            </svg>
            我的专利</MenuItem
          >
          <MenuItem name="/trademarkMonitor" class="lefttit">
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_71_39915)">
                <g>
                  <path
                    d="M5.54313 14.0581H2.5085V14.9685H13.4331V14.0581H5.54313ZM14.0399 1.00977H1.90155C1.39866 1.00977 0.991211 1.41691 0.991211 1.92012V10.4166C0.991211 10.9193 1.39866 11.3271 1.90155 11.3271H14.0399C14.5426 11.3271 14.9504 10.9193 14.9504 10.4166V1.92012C14.9504 1.41691 14.5426 1.00977 14.0399 1.00977ZM14.16 10.1905H14.1599C14.1599 10.3616 14.0213 10.5 13.8504 10.5H2.09115C1.9201 10.5 1.78165 10.3616 1.78165 10.1905V2.14501C1.78165 1.97402 1.9201 1.83557 2.09115 1.83557H13.8504C14.0213 1.83557 14.16 1.97401 14.16 2.14501V10.1905H14.16ZM10.6251 13.297V12.4359H5.48314V13.297H10.6251ZM9.90771 2.97846H9.04657V9.15162H9.90771V2.97846ZM12.6419 3.99373H11.7807V9.1836H12.6419V3.99373ZM7.06164 4.95303H6.2005V9.13565H7.06164V4.95303ZM4.35947 5.97629H3.49833V9.15164H4.35947V5.97629Z"
                    fill="#919498"
                  />
                </g>
              </g>
              <defs>
                <clipPath>
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            商标监控</MenuItem
          > -->
          <!-- <div @click="goKsy('client/serviceList?tab=2')" class="lefttit">
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.4731 5.17177L10.5494 4H14.0263L13.9501 5.17177H12.537L12.0855 12H11.3937L11.8452 5.17177H10.4731Z"
                fill="#919498"
              />
              <path
                d="M8.75789 4C8.97678 4 9.10382 4.19174 9.139 4.57523L9.80742 12H9.07451L8.88102 9.68842H6.98717L6.47707 12H5.7207L7.40933 4.49001C7.4836 4.16334 7.62041 4 7.81976 4H8.75789ZM7.9898 5.17177L7.24516 8.51664H8.78134L8.4999 5.17177H7.9898Z"
                fill="#919498"
              />
              <path
                d="M3.02608 12C2.82672 12 2.70555 11.7727 2.66255 11.3182L2 4H2.73291L3.31924 10.8282H3.81176L5.33035 4H6.08671L4.42154 11.4141C4.37463 11.6272 4.31795 11.7763 4.2515 11.8615C4.18505 11.9538 4.10492 12 4.01111 12H3.02608Z"
                fill="#919498"
              />
            </svg>
            VAT服务
          </div>
          <div @click="goKsy('client/serviceList?tab=4')" class="lefttit">
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.6697 4C13.0965 4.0071 13.4249 4.17754 13.655 4.51132C13.8851 4.83799 14.0001 5.3138 14.0001 5.93875C14.0001 6.01687 13.996 6.14115 13.9876 6.31158L13.9625 6.66312C13.9123 7.30937 13.7784 7.82068 13.5608 8.19707C13.3475 8.57346 13.0588 8.81136 12.6948 8.91079L13.975 12H13.0714L11.879 8.96405H11.0192L10.7996 12H10.0591L10.6364 4H12.6697ZM12.4124 7.81358C12.6509 7.80648 12.835 7.72126 12.9647 7.55792C13.0985 7.39458 13.1801 7.11407 13.2094 6.71638L13.2471 6.25832C13.2513 6.20861 13.2533 6.14114 13.2533 6.05593C13.2533 5.73635 13.199 5.5091 13.0902 5.37417C12.9814 5.23213 12.8203 5.15757 12.607 5.15047H11.2954L11.1008 7.81358H12.4124Z"
                fill="#919498"
              />
              <path
                d="M8.40375 4C8.83885 4.0071 9.17355 4.18464 9.40784 4.53262C9.64631 4.8735 9.76554 5.36707 9.76554 6.01332C9.76554 6.19086 9.76136 6.32934 9.75299 6.42876L9.71534 6.97204C9.65677 7.75322 9.48105 8.35331 9.18819 8.7723C8.89533 9.1842 8.50416 9.3937 8.01466 9.4008H6.73445L6.54618 12H5.80566L6.38302 4H8.40375ZM8.11507 8.22903C8.37446 8.22193 8.57319 8.12605 8.71125 7.94141C8.84931 7.74967 8.93508 7.44785 8.96855 7.03595L9.01875 6.38615C9.02294 6.33644 9.02503 6.26897 9.02503 6.18375C9.02503 5.83577 8.96855 5.58367 8.85559 5.42743C8.74681 5.26409 8.57528 5.17887 8.34099 5.17177H7.04195L6.81603 8.22903H8.11507Z"
                fill="#919498"
              />
              <path
                d="M2.57735 4H5.61472L5.53314 5.15047H3.23629L3.07312 7.37683H5.0813L4.99972 8.51664H2.99154L2.8221 10.8389H5.17543L5.09385 12H2L2.57735 4Z"
                fill="#919498"
              />
            </svg>
            EPR服务
          </div> -->
          <!-- <Submenu name="4">
            <template slot="title">
              <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.9714 3.8C12.9714 3.66076 13.0256 3.52723 13.1221 3.42877C13.2185 3.33031 13.3493 3.275 13.4857 3.275C13.6221 3.275 13.7529 3.33031 13.8494 3.42877C13.9458 3.52723 14 3.66076 14 3.8V13.075C14 14.1381 13.1557 15 12.1143 15H3.88571C2.84429 15 2 14.1381 2 13.075V2.925C2 1.86187 2.84429 1 3.88571 1H13.4857C13.6221 1 13.7529 1.05531 13.8494 1.15377C13.9458 1.25223 14 1.38576 14 1.525C14 1.66424 13.9458 1.79777 13.8494 1.89623C13.7529 1.99469 13.6221 2.05 13.4857 2.05H3.88571C3.77315 2.05 3.66169 2.07263 3.5577 2.11661C3.45371 2.16058 3.35922 2.22503 3.27962 2.30628C3.20003 2.38753 3.13689 2.48399 3.09382 2.59015C3.05074 2.69631 3.02857 2.81009 3.02857 2.925V13.075C3.02857 13.1899 3.05074 13.3037 3.09382 13.4098C3.13689 13.516 3.20003 13.6125 3.27962 13.6937C3.35922 13.775 3.45371 13.8394 3.5577 13.8834C3.66169 13.9274 3.77315 13.95 3.88571 13.95H12.1143C12.2268 13.95 12.3383 13.9274 12.4423 13.8834C12.5463 13.8394 12.6408 13.775 12.7204 13.6937C12.8 13.6125 12.8631 13.516 12.9062 13.4098C12.9493 13.3037 12.9714 13.1899 12.9714 13.075V3.8ZM5.25714 6.775C5.12075 6.775 4.98994 6.71969 4.89349 6.62123C4.79704 6.52277 4.74286 6.38924 4.74286 6.25C4.74286 6.11076 4.79704 5.97722 4.89349 5.87877C4.98994 5.78031 5.12075 5.725 5.25714 5.725H10.7429C10.8793 5.725 11.0101 5.78031 11.1065 5.87877C11.203 5.97722 11.2571 6.11076 11.2571 6.25C11.2571 6.38924 11.203 6.52277 11.1065 6.62123C11.0101 6.71969 10.8793 6.775 10.7429 6.775H5.25714ZM5.25714 9.575C5.12075 9.575 4.98994 9.51969 4.89349 9.42123C4.79704 9.32277 4.74286 9.18924 4.74286 9.05C4.74286 8.91076 4.79704 8.77722 4.89349 8.67877C4.98994 8.58031 5.12075 8.525 5.25714 8.525H8.68571C8.82211 8.525 8.95292 8.58031 9.04937 8.67877C9.14582 8.77722 9.2 8.91076 9.2 9.05C9.2 9.18924 9.14582 9.32277 9.04937 9.42123C8.95292 9.51969 8.82211 9.575 8.68571 9.575H5.25714Z"
                  fill="#919498"
                />
              </svg>
              订单管理
            </template>
            <MenuItem name="/myOrder">我的订单</MenuItem>
            <MenuItem name="/coupon">我的优惠券</MenuItem>
            <MenuItem name="/integralMal">积分商城</MenuItem>
          </Submenu> -->
          <MenuItem name="/myOrder" class="lefttit">
            <svg
              t="1720693198006"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6971"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="16"
              height="16"
            >
              <path
                d="M620.79 195.43H389.25c-0.6 0-1.1-0.49-1.1-1.1V96.35c0-0.6 0.49-1.1 1.1-1.1H620.8c0.6 0 1.1 0.49 1.1 1.1v97.98c-0.01 0.61-0.5 1.1-1.11 1.1z"
                p-id="6972"
                fill="#c2c5c6"
              ></path>
              <path
                d="M743.12 159.74h-90.99c-1.35 32.91-28.49 59.47-61.73 59.47H419.63c-33.22 0-60.38-26.56-61.73-59.47h-90.98c-50.31 0-91.46 41.15-91.46 91.46v518.3c0 50.3 41.15 91.46 91.46 91.46h476.19c50.31 0 91.46-41.16 91.46-91.46V251.2c0.01-50.31-41.14-91.46-91.45-91.46z m-66.55 512.24h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.63-10.22 22.86-22.86 22.86z m0-139.37h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.63-10.22 22.86-22.86 22.86z m0-139.38h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.64-10.22 22.86-22.86 22.86z"
                p-id="6973"
                fill="#c2c5c6"
              ></path>
            </svg>
            我的订单</MenuItem
          >
          <MenuItem name="/invoiceList" class="lefttit">
            <svg
              t="1720693198006"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6971"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="16"
              height="16"
            >
              <path
                d="M620.79 195.43H389.25c-0.6 0-1.1-0.49-1.1-1.1V96.35c0-0.6 0.49-1.1 1.1-1.1H620.8c0.6 0 1.1 0.49 1.1 1.1v97.98c-0.01 0.61-0.5 1.1-1.11 1.1z"
                p-id="6972"
                fill="#c2c5c6"
              ></path>
              <path
                d="M743.12 159.74h-90.99c-1.35 32.91-28.49 59.47-61.73 59.47H419.63c-33.22 0-60.38-26.56-61.73-59.47h-90.98c-50.31 0-91.46 41.15-91.46 91.46v518.3c0 50.3 41.15 91.46 91.46 91.46h476.19c50.31 0 91.46-41.16 91.46-91.46V251.2c0.01-50.31-41.14-91.46-91.45-91.46z m-66.55 512.24h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.63-10.22 22.86-22.86 22.86z m0-139.37h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.63-10.22 22.86-22.86 22.86z m0-139.38h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.64-10.22 22.86-22.86 22.86z"
                p-id="6973"
                fill="#c2c5c6"
              ></path>
            </svg>
            我的发票</MenuItem
          >
          <!-- <Submenu name="3" v-show="PROCESS_ENV.NODE_PLA !== 'wg'">
            <template slot="title">
              <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.1429 10C10.105 10 10.0686 10.0151 10.0418 10.0418C10.0151 10.0686 10 10.105 10 10.1429V13.7143C10 13.733 10.0037 13.7516 10.0109 13.769C10.0181 13.7863 10.0286 13.802 10.0418 13.8153C10.0551 13.8286 10.0709 13.8391 10.0882 13.8463C10.1055 13.8535 10.1241 13.8572 10.1429 13.8572H13.7143C13.733 13.8572 13.7516 13.8535 13.769 13.8463C13.7863 13.8391 13.802 13.8286 13.8153 13.8153C13.8286 13.802 13.8391 13.7863 13.8463 13.769C13.8535 13.7516 13.8572 13.733 13.8572 13.7143V10.1429C13.8572 10.1241 13.8535 10.1055 13.8463 10.0882C13.8391 10.0709 13.8286 10.0551 13.8153 10.0418C13.802 10.0286 13.7863 10.0181 13.769 10.0109C13.7516 10.0037 13.733 10 13.7143 10H10.1429ZM10.1429 8.85714H13.7143C14.0553 8.85714 14.3823 8.9926 14.6234 9.23372C14.8645 9.47484 15 9.80187 15 10.1429V13.7143C15 14.0553 14.8645 14.3823 14.6234 14.6234C14.3823 14.8645 14.0553 15 13.7143 15H10.1429C9.80187 15 9.47484 14.8645 9.23372 14.6234C8.9926 14.3823 8.85714 14.0553 8.85714 13.7143V10.1429C8.85714 9.80187 8.9926 9.47484 9.23372 9.23372C9.47484 8.9926 9.80187 8.85714 10.1429 8.85714ZM10.1429 2.14285C10.1241 2.14285 10.1055 2.14654 10.0882 2.15372C10.0709 2.1609 10.0551 2.17143 10.0418 2.18469C10.0286 2.19796 10.0181 2.21371 10.0109 2.23104C10.0037 2.24838 10 2.26695 10 2.28572V5.85714C10 5.89503 10.0151 5.93136 10.0418 5.95815C10.0686 5.98494 10.105 5.99999 10.1429 5.99999H13.7143C13.733 6 13.7516 5.9963 13.769 5.98912C13.7863 5.98195 13.802 5.97142 13.8153 5.95816C13.8286 5.94489 13.8391 5.92914 13.8463 5.91181C13.8535 5.89448 13.8572 5.8759 13.8572 5.85714V2.28572C13.8572 2.26695 13.8535 2.24837 13.8463 2.23104C13.8391 2.2137 13.8286 2.19795 13.8153 2.18469C13.802 2.17142 13.7863 2.1609 13.769 2.15372C13.7516 2.14654 13.733 2.14284 13.7143 2.14285H10.1429ZM10.1429 1H13.7143C14.0553 1 14.3823 1.13546 14.6234 1.37658C14.8645 1.6177 15 1.94472 15 2.28572V5.85714C15 6.19813 14.8645 6.52516 14.6234 6.76628C14.3823 7.0074 14.0553 7.14286 13.7143 7.14286H10.1429C9.80187 7.14286 9.47484 7.0074 9.23372 6.76628C8.9926 6.52516 8.85714 6.19813 8.85714 5.85714V2.28572C8.85714 1.94472 8.9926 1.6177 9.23372 1.37658C9.47484 1.13546 9.80187 1 10.1429 1ZM2.28572 10C2.26695 10 2.24838 10.0037 2.23104 10.0109C2.21371 10.0181 2.19796 10.0286 2.18469 10.0418C2.17143 10.0551 2.1609 10.0709 2.15372 10.0882C2.14654 10.1055 2.14285 10.1241 2.14285 10.1429V13.7143C2.14284 13.733 2.14654 13.7516 2.15372 13.769C2.1609 13.7863 2.17142 13.802 2.18469 13.8153C2.19795 13.8286 2.2137 13.8391 2.23104 13.8463C2.24837 13.8535 2.26695 13.8572 2.28572 13.8572H5.85714C5.8759 13.8572 5.89448 13.8535 5.91181 13.8463C5.92914 13.8391 5.94489 13.8286 5.95816 13.8153C5.97142 13.802 5.98195 13.7863 5.98912 13.769C5.9963 13.7516 6 13.733 5.99999 13.7143V10.1429C5.99999 10.105 5.98494 10.0686 5.95815 10.0418C5.93136 10.0151 5.89503 10 5.85714 10H2.28572ZM2.28572 8.85714H5.85714C6.19813 8.85714 6.52516 8.9926 6.76628 9.23372C7.0074 9.47484 7.14286 9.80187 7.14286 10.1429V13.7143C7.14286 14.0553 7.0074 14.3823 6.76628 14.6234C6.52516 14.8645 6.19813 15 5.85714 15H2.28572C1.94472 15 1.6177 14.8645 1.37658 14.6234C1.13546 14.3823 1 14.0553 1 13.7143V10.1429C1 9.80187 1.13546 9.47484 1.37658 9.23372C1.6177 8.9926 1.94472 8.85714 2.28572 8.85714ZM2.28572 2.14285C2.26695 2.14284 2.24837 2.14654 2.23104 2.15372C2.2137 2.1609 2.19795 2.17142 2.18469 2.18469C2.17142 2.19795 2.1609 2.2137 2.15372 2.23104C2.14654 2.24837 2.14284 2.26695 2.14285 2.28572V5.85714C2.14285 5.8759 2.14654 5.89448 2.15372 5.91181C2.1609 5.92914 2.17143 5.94489 2.18469 5.95816C2.19796 5.97142 2.21371 5.98195 2.23104 5.98912C2.24838 5.9963 2.26695 6 2.28572 5.99999H5.85714C5.89503 5.99999 5.93136 5.98494 5.95815 5.95815C5.98494 5.93136 5.99999 5.89503 5.99999 5.85714V2.28572C6 2.26695 5.9963 2.24838 5.98912 2.23104C5.98195 2.21371 5.97142 2.19796 5.95816 2.18469C5.94489 2.17143 5.92914 2.1609 5.91181 2.15372C5.89448 2.14654 5.8759 2.14285 5.85714 2.14285H2.28572ZM2.28572 1H5.85714C6.19813 1 6.52516 1.13546 6.76628 1.37658C7.0074 1.6177 7.14286 1.94472 7.14286 2.28572V5.85714C7.14286 6.19813 7.0074 6.52516 6.76628 6.76628C6.52516 7.0074 6.19813 7.14286 5.85714 7.14286H2.28572C1.94472 7.14286 1.6177 7.0074 1.37658 6.76628C1.13546 6.52516 1 6.19813 1 5.85714V2.28572C1 1.94472 1.13546 1.6177 1.37658 1.37658C1.6177 1.13546 1.94472 1 2.28572 1Z"
                  fill="#919498"
                />
              </svg>
              工具箱
            </template>
            <MenuItem name="/myCollection">我的收藏</MenuItem>
          </Submenu> -->
          <MenuItem name="/user" class="lefttit">
            <svg
              t="1720693250176"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8991"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="16"
              height="16"
            >
              <path
                d="M511.999488 66.861804c-245.825778 0-445.138196 199.284789-445.138196 445.138196 0 245.852384 199.312418 445.137173 445.138196 445.137173 245.880013 0 445.138196-199.284789 445.138196-445.137173C957.137685 266.146593 757.879502 66.861804 511.999488 66.861804zM750.761384 762.417353c-15.377222 0-27.821649-12.443403-27.821649-27.821649 0-116.2834-94.602611-210.886011-210.94127-210.886011-116.2834 0-210.886011 94.603635-210.886011 210.886011 0 15.377222-12.443403 27.821649-27.821649 27.821649s-27.821649-12.443403-27.821649-27.821649c0-117.070322 76.399017-215.667921 181.543729-251.368004-49.502437-29.28907-83.137489-82.675978-83.137489-144.267754 0-92.727914 75.420737-168.17628 168.122045-168.17628s168.123069 75.448366 168.123069 168.17628c0 61.591777-33.580816 114.979708-83.137489 144.267754 105.198947 35.700083 181.597965 134.297682 181.597965 251.368004C778.583033 749.97395 766.138606 762.417353 750.761384 762.417353z"
                fill="#c2c5c6"
                p-id="8992"
              ></path>
              <path
                d="M511.999488 226.425939c-62.000076 0-112.479771 50.480718-112.479771 112.534006 0 62.026682 50.479695 112.5074 112.479771 112.5074 62.055334 0 112.480794-50.480718 112.480794-112.5074C624.480282 276.905634 574.0538 226.425939 511.999488 226.425939z"
                fill="#c2c5c6"
                p-id="8993"
              ></path>
            </svg>
            账户管理</MenuItem
          >
        </Menu>
      </Sider>
    </div>
  </div>
</template>
<script>
import '@/assets/style/common.less';
import { getInfo1 } from '@/api/user/userModule';
export default {
  components: {},
  props: {},
  data() {
    return {
      contentStyleObj: {
        height: '',
      },
      resNum: 0,
      tarNum: 0,
      suspendAdvertisement: false,
      GBchecked: false,
      DEchecked: false,
      activeOpen: [],
      userInfo: {},
      path: location.pathname.split('/').splice(-1)[0],
      openNames: [],
    };
  },
  computed: {
    activeName() {
      return this.$route.path;
    },
    inviteBox() {
      return this.$store.state.login.isShowActiveImg;
    },
    carNum() {
      return this.$store.state.breadcrumb.carNum;
    },
  },
  watch: {
    $route(to, from) {
      if (
        to.path === '/myOrder' ||
        to.path === '/myPatent' ||
        to.path === '/myBrand' ||
        to.path === '/trademarkDeal' ||
        to.path === '/coupon'
      ) {
        sessionStorage.setItem('leftPath', to.path);
        this.$store.commit('saveMenuName', to.path);
        this.$store.commit('activeOpen', ['1']);
        this.activeOpen = ['1'];
        sessionStorage.setItem('activeOpen', JSON.stringify(['1']));
        this.$refs.menu.updateActiveName();
      } else if (to.path === '/securitySetting') {
        sessionStorage.setItem('leftPath', to.path);
        this.$store.commit('saveMenuName', to.path);
        this.$store.commit('activeOpen', ['2']);
        this.activeOpen = ['2'];
        sessionStorage.setItem('activeOpen', JSON.stringify(['2']));
        this.$refs.menu.updateActiveName();
      } else if (to.path === '/trademarkName') {
        sessionStorage.setItem('leftPath', to.path);
        this.$store.commit('saveMenuName', to.path);
        this.$store.commit('activeOpen', ['4']);
        this.activeOpen = ['4'];
        sessionStorage.setItem('activeOpen', JSON.stringify(['4']));
        this.$refs.menu.updateActiveName();
      } else if (to.path === '/user') {
        sessionStorage.setItem('leftPath', to.path);
        this.$store.commit('saveMenuName', to.path);
        this.$store.commit('activeOpen', ['5']);
        this.activeOpen = ['5'];
        sessionStorage.setItem('activeOpen', JSON.stringify(['5']));
        this.$refs.menu.updateActiveName();
      } else {
        sessionStorage.setItem('leftPath', to.path);
        this.$store.commit('saveMenuName', to.path);
        this.$store.commit('activeOpen', ['3']);
        this.activeOpen = ['3'];
      }
      this.path = location.pathname.split('/').splice(-1)[0];
    },
  },
  methods: {
    toHomePage() {
      window.location.href = this.homePageUrl;
    },
    //菜单展开收起
    openNamesChange(val) {
      this.openNames = val;
    },
    // 屏幕高度
    getHeight() {
      this.contentStyleObj.height = window.screen.height - 1600 + 'px';
    },
    changeMenu(name) {
      let url = window.location.pathname;
      sessionStorage.setItem('leftPath', name);
      this.$store.commit('saveMenuName', name);
      // if (name == "/myBrand"||name=='/coupon'||name=='/myOrder') {
      //   this.$store.dispatch("changeStatus", true);
      // } else {
      //   this.$store.dispatch("changeStatus", false);
      // }
      let worMenukList = ['/myBrand', '/myOrder', '/trademarkDeal', '/coupon'];
      let userMenuList = ['/user', '/securitySetting'];
      let trademarkNameList = ['/trademarkName'];
      var menuType = [];
      if (worMenukList.includes(name)) {
        menuType = ['1'];
      } else if (userMenuList.includes(name)) {
        menuType = ['2'];
      } else if (trademarkNameList.includes(name)) {
        menuType = ['4'];
      } else {
        menuType = ['3'];
      }
      this.$store.commit('activeOpen', menuType);
      this.activeOpen = menuType;
      sessionStorage.setItem('activeOpen', JSON.stringify(menuType));
      let status = localStorage.getItem('orderStatus');
      // if ((url.indexOf('/infoDetail') > -1 ) && (status == 28 || status == 32 || status == 0 || status == 8)) {
      // if (url.indexOf('/infoDetail') > -1 && status != 3) {
      //   this.$Modal.confirm({
      //     title: '温馨提示',
      //     content: '本页面如有填写资料，请先点击页面底部的保存按钮保存资料，再离开',
      //     okText: '我已点保存按钮',
      //     cancelText: '还没点保存按钮',
      //     onOk: () => {
      //       this.updataMenu();
      //       this.$router.push({ path: name });
      //     },
      //   });
      //   return;
      // }
      this.updataMenu();
      this.$router.push({ path: name });
    },
    closeBtn() {
      this.suspendAdvertisement = false;
      sessionStorage.setItem('suspendAdvertisement', false);
    },
    updataMenu() {
      this.activeOpen = this.$store.state.login.menuOpen;
      this.$nextTick(() => {
        this.$refs.menu.updateActiveName();
        this.$refs.menu.updateOpened();
      });
    },
    showSuspendAdvertisement() {
      if (sessionStorage.getItem('suspendAdvertisement')) {
        this.$nextTick(() => {
          this.suspendAdvertisement = sessionStorage.getItem('suspendAdvertisement') != 'false';
        });
      }
    },
    changeState(val) {
      this.$store.commit('saveActiveStatus', val);
    },
    goHome() {
      window.location.href = this.homePageUrl + 'productservice';
    },
    goServiceList() {
      this.$router.push({ path: '/serviceList' });
    },
    goKsy(url) {
      let tokenl = localStorage.getItem('token');
      let sid = localStorage.getItem('sessionId');
      window.open(this.homePageUrlKsy + url + `&t=${tokenl}&s=${sid}`);
    },
    goWork() {
      this.$router.push({ path: '/work' });
    },
    getUinfo() {
      getInfo1()
        .then(
          (res) => {
            if (res.code === 0) {
              localStorage.setItem('objInfo', JSON.stringify(res.data));
              this.userInfo = res.data;
            } else {
              this.$Message.error(res.message);
            }
          },
          (err) => {
            this.$Message.error(err.message);
          }
        )
        .finally(() => {});
    },
  },
  created() {
    this.getHeight();
    this.userInfo = JSON.parse(localStorage.getItem('objInfo'));
    if (!this.userInfo.userMobile) {
      this.getUinfo();
    }
    try {
      let leftPath = window.sessionStorage.leftPath;
      if (leftPath) {
        this.$store.commit('saveMenuName', leftPath);
      }
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    try {
      let activeOpen = JSON.parse(window.sessionStorage.activeOpen);
      if (activeOpen) {
        this.$store.commit('activeOpen', activeOpen);
        this.activeOpen = activeOpen;
        this.updataMenu();
      }
    } catch (error) {
      let activeOpen = ['1'];
      this.$store.commit('activeOpen', activeOpen);
      this.activeOpen = activeOpen;
      this.updataMenu();
    }
    this.openNames = ['1'];
  },
};
</script>
<style lang="less" scoped>
.layout {
  width: 214px;
  background: #f3f8ff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  box-shadow: 0px 5px 10px 0px #00000040;
  z-index: 1004;
  /* 设置滚动条本身的样式 */
  &::-webkit-scrollbar {
    width: 0px; /* 设置滚动条宽度 */
    height: 0px; /* 设置滚动条高度 */
    background-color: transparent; /* 设置滚动条背景色为透明 */
  }

  .top-info {
    margin-top: 14px;
    text-align: center;
    img {
      width: 78px;
      height: 78px;
      border-radius: 50%;
    }
    .nickname {
      color: #333333;
      margin-top: 4px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    .account-info {
      font-family: PingFangSC;
      color: #333333;
      margin-top: 6px;
      font-size: 12px;
    }
  }
  .side_menu {
    // background-color: #fff;
    width: 216px;
    padding-bottom: 102px;
    position: relative;
  }
  &/deep/ .ivu-layout-sider {
    min-height: 70vh;
    max-height: 1300px;
    width: 214px !important;
    max-width: 214px !important;
  }
  &/deep/ .ivu-layout-sider-children {
    .ivu-menu-item-group {
      color: #333333;
      .ivu-menu-item-selected span {
        color: @primary-color;
      }
      .ivu-menu-vertical .ivu-menu-item:hover,
      .ivu-menu-vertical .ivu-menu-submenu-title:hover {
        color: @primary-color;
      }
    }
  }
}
.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  color: @primary-color;
}
.redNum {
  color: #ff6600;
}
.menu-text {
  padding-left: 46px;
  height: 40px;
  line-height: 40px;
  border-radius: 2px;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  color: #fff;
  border: none;
  font-weight: bold;
  background: @brandColor;
  border-radius: 0;
  .redNum {
    color: #3a7fff;
  }
  svg path {
    fill: #fff;
  }
  &.menu-item-sub {
    background-color: #f8f9fd;
    .menu-text {
      background: @brandColor;
    }
  }
}
.ivu-menu-vertical.ivu-menu-light:after {
  width: 0px;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
  width: 0;
}

&/deep/.ivu-menu-item {
  // height: 42px;
  border-radius: 4px;
  // margin-left: 4px;
  line-height: 15px;
  font-size: 14px;
  padding: 15px 24px;
  font-weight: normal !important;
  img {
    margin-right: 5px;
    // float: left;
    // margin-top: -5px;
  }
  .ivu-badge {
    text-indent: 0px;
  }
}
&/deep/.ivu-menu-submenu-title {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  padding-left: 36px;
  svg {
    margin: 2px 5px 0 0;
    vertical-align: top;
  }
}

&/deep/.ivu-menu-vertical .ivu-menu-item-group-title {
  height: 0px;
}

&/deep/.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  color: @primary-color;
}

/deep/ .ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {
  padding: 3px 15px !important;
  color: #666666;
}
/deep/ .ivu-menu-vertical .ivu-menu-submenu-title-icon {
  right: 15px;
  color: #666666;
}
/deep/ .ivu-layout-sider {
  background: #f3f8ff;
}
/deep/ .ivu-menu-vertical .ivu-menu-item,
.ivu-menu-vertical .ivu-menu-submenu-title {
  // padding: 10px 18px;
}
/deep/ .ivu-menu {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
}
/deep/ .ivu-menu-submenu {
  .ivu-menu {
    background-color: #fff;
    padding: 15px 0;
  }
}
/deep/.ivu-menu-submenu {
  .ivu-menu-item {
    background: #fff;
  }
}
/deep/.ivu-menu-light {
  background-color: #f3f8ff;
}
.lefttit {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  padding: 0px 16px 0 36px;
  cursor: pointer;
  height: 48px;
  line-height: 48px;
  margin-bottom: 5px;
  font-weight: normal !important;
  svg {
    margin: 16px 5px 0 0;
    vertical-align: top;
    transform: scale(1.1);
  }
}
.lefttit:hover {
  color: @primary-color;
}
.lefttit-active {
  background: @brandColor;
  color: #fff;
  svg path {
    fill: #fff;
  }
}
.lefttit-active:hover {
  color: #fff;
}
.img-active {
  transform: translateX(-move);
  filter: drop-shadow(color, move, 0);
}
.dividing-line {
  width: 213px;
  height: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin: 8px auto;
}
.ip_logo {
  width: 140px;
  margin: 16px auto 10px;
  display: block;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/menuLeft.vue